<template>
  <span>
    <v-card>
      <v-card-text>
        <v-tooltip  left lazy>
          <v-btn slot="activator" icon @click="deleteDialog = true">
            <v-icon color="red">remove_circle</v-icon>
          </v-btn>
          <span>Remove student</span>
        </v-tooltip>
        <span>
          <v-avatar size="42px">
            <img :src="student.profile.image" class="mr-3">
          </v-avatar>
        </span>
        <span>{{student.profile.given_name}} {{student.profile.family_name}} {{student.profile.ext_name}}</span>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>

    <v-layout row justify-center>
      <v-dialog v-model="deleteDialog" persistent max-width="300">
        <v-card>
          <v-card-title class="headline">Removing {{student.profile.given_name}} {{student.profile.family_name}} {{student.profile.ext_name}}</v-card-title>
          <v-card-text>
            <p>Are you sure you want to remove this student?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" flat @click="deleteDialog = false" :disabled="loading">Close</v-btn>
            <v-btn 
              dark
              color="red" 
              :loading="loading"
              :disabled="loading"
              @click="removeStudent"
            >
              Remove
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

  </span>
</template>

<script>
import axios from 'axios'
export default {
  props: ['student', 'fetchStudents'],
  data(){
    return {
      deleteDialog: false,
      loading: false
    }
  },
  methods: {
    async removeStudent(){
      try{
        this.loading = true
        let res = await axios.post(`/api/class/${this.$route.params.id}/remove`, null, {
          params: {
            ids: [this.student.student_id]
          },
          headers: { 
            'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` 
          }
        })
        console.log(res)
        this.loading = false
        this.deleteDialog = false
        this.fetchStudents()
      }catch(e){
        this.loading = false
        console.log(e)

      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Instructor/Classroom/Students.vue